import { defineComponent as _defineComponent } from 'vue'
import PreviousAddressesForms from './PreviousAddressesForms.vue';


import { previousAddressesFormsEmitsDef, previousAddressesFormsProps } from './PreviousAddressesForms.vue';

const { previousAddressesParentClass, ...props } = previousAddressesFormsProps;

export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingPreviousAddressesForms',
  props: props,
  emits: previousAddressesFormsEmitsDef,
  setup(__props) {





return { __sfc: true,previousAddressesParentClass, props, PreviousAddressesForms }
}

})